import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a523e532cc250001424e18b_1783781302987_372cb42e/vinci/src/app/game-setup/components/GameSetupClient.tsx");
